// removed by extract-text-webpack-plugin
module.exports = {"noDiscounts":"prices__noDiscounts-2Tz-k","rouble":"prices__rouble-2Ny3L"};


//////////////////
// WEBPACK FOOTER
// ./components/common/prices/prices.css
// module id = 829
// module chunks = 0